var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#CFCFCF",
    cx: 20.5,
    cy: 20.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,10 C21.1655295,10 21.8124764,10.1238176 22.4,10.38 C23.0878168,10.6190954 23.6573777,10.9410212 24.3,11.52 C24.6603153,11.7334657 25.0689134,12.179209 25.44,12.66 C25.7003926,13.1697646 25.85826,13.665035 25.82,14.18 L25.82,17.22 C25.85826,17.4910412 25.8211147,17.9058302 25.82,18.36 C25.6725314,18.846858 25.5487138,19.3266512 25.44,19.88 C25.2020193,20.3048249 24.9729568,20.7753317 24.68,21.4 C24.4033873,21.6792137 24.056698,22.0661437 23.54,22.54 L28.86,24.82 L29.24,25.2 C29.8049873,25.3999685 30,25.6816535 30,25.96 L30,27.86 C30,28.1518426 29.8854687,28.4273367 29.62,28.62 C29.4273367,28.8854687 29.1518426,29 28.86,29 L12.14,29 C11.8543483,29 11.5726633,28.8854687 11.38,28.62 C11.1145313,28.4273367 11,28.1518426 11,27.86 L11,25.96 C11,25.7064174 11.1981082,25.4309233 11.76,25.2 L12.14,24.82 L17.46,22.54 C16.9866385,22.0537618 16.6337583,21.6513546 16.32,21.02 C16.0641889,20.7103267 15.8320309,20.2305336 15.56,19.88 C15.4729545,19.2523599 15.3460414,18.7756621 15.18,18.36 C15.1974581,17.8470163 15.1603128,17.4538954 15.18,17.22 L15.18,14.18 C15.1603128,13.665035 15.3150848,13.1697646 15.56,12.66 C15.9341821,12.179209 16.3396847,11.7334657 16.7,11.52 C17.3426223,10.9410212 17.9152786,10.6190954 18.6,10.38 C19.2030009,10.1238176 19.8530433,10 20.5,10 Z",
    id: "User---simple-line-icons",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.279a15641832ba8fb012f6cc99fc8732.svg";
export { ForwardRef as ReactComponent };